/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from 'react-intl';
import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/formats.module.scss';

const propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    formats: AppPropTypes.formats,
    className: PropTypes.string,
};

const defaultProps = {
    title: null,
    formats: [],
    className: null,
};

const Formats = ({ title, formats, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        {title !== null ? <h4 className={styles.title}>{title}</h4> : null}
        <div className={styles.formats}>
            {(formats || []).map(
                (
                    {
                        type = null,
                        year = null,
                        number = null,
                        episodesCount = null,
                        duration = null,
                        label = null,
                    },
                    i,
                ) => {
                    let inner = null;
                    switch (type) {
                        case 'custom':
                            inner = label;
                            break;
                        case 'unique':
                            inner = `${year} x ${duration}`;
                            break;
                        case 'season':
                            // console.log(type);
                            inner =
                                duration !== null ? (
                                    <FormattedMessage
                                        defaultMessage="Season {number}, {episodesCount} episodes of {duration}min, {year}"
                                        description="Format label"
                                        values={{ number, episodesCount, duration, year }}
                                    />
                                ) : (
                                    <FormattedMessage
                                        defaultMessage="Season {number}, {episodesCount} episodes, {year}"
                                        description="Format label"
                                        values={{ number, episodesCount, duration, year }}
                                    />
                                );
                            break;
                        default:
                            break;
                    }
                    return inner !== null ? (
                        <div
                            className={classNames([styles.format, { [styles[type]]: true }])}
                            key={`formats-${i + 1}`}
                        >
                            <h2 className={styles.item}>{inner}</h2>
                        </div>
                    ) : null;
                },
            )}
        </div>
    </div>
);
Formats.propTypes = propTypes;
Formats.defaultProps = defaultProps;

export default Formats;
